// This import loads the firebase namespace along with all its type information.
import GenericResult from './generic-result-model'

export async function load_genericResults(): Promise<GenericResult[]> {
  throw 'Not implemented'
}

export async function delete_genericResult(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_genericResult(): Promise<GenericResult> {
  throw 'Not implemented'
}
